/* import __COLOCATED_TEMPLATE__ from './item-detail-line-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();